import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { InvoiceService } from './invoices.service';

@Component({
  selector: 'app-invoices-smart',
  template: `<app-report-invoices [allInvoices]="allInvoices" [invoicePayment]="invoicePayment" [pendingAmounts]="pendingAmounts"></app-report-invoices>`,
  styles: [
  ]
})
export class InvoicesSmartComponent extends FeaturesBaseComponent implements OnInit {
  allInvoices: any = [];
  pendingAmounts: any;
  currentDate: Date;
  startFromDate: any;
  ocassionRewards: any;
  invoicePayment:any;
  constructor(private invoiceService: InvoiceService) {
    super();
    this.currentDate = new Date();
    this.startFromDate = this.currentDate.setDate(this.currentDate.getDate() - 30);
    let startDate = formatDate(this.startFromDate, 'yyyy-MM-dd', 'en');
    let endDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    

    const getAllInvoice = this.invoiceService.getAllInvoicesRange(startDate, endDate);
    const getPendingAmountData = this.invoiceService.getPendingAmountData(startDate, endDate);
    const getinvoicePaymentData = this.invoiceService.getinvoicepayments(startDate, endDate);

    forkJoin([getAllInvoice, getPendingAmountData,getinvoicePaymentData]).subscribe(
      res=> {
        this.allInvoices = res[0]['data'];
        this.pendingAmounts = res[1]['data'];
        this.invoicePayment = res[2]['data'];
        // 
      }
    )
  }
  
  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy(){
    super.ngOnDestroy()
  }


}
